export const useCachedResponse = {
  'Cache-Control': 'max-age=600', // upto 10 mins of cached response
}
